<template>
<div class="view-port clearfix" id="chat">
  <div class="view bg-white">
    <!-- BEGIN View Header !-->
    <div class="navbar navbar-default">
      <div class="navbar-inner">
        <!-- BEGIN Header Controler !-->
        <a href="javascript:;" class="inline action p-l-10 link text-master" data-navigate="view" data-view-port="#chat" data-view-animation="push-parrallax">
          <i class="pg-plus"></i>
        </a>
        <!-- END Header Controler !-->
        <div class="view-heading">
          Chat List
          <div class="fs-11">Show All</div>
        </div>
        <!-- BEGIN Header Controler !-->
        <a href="#" class="inline action p-r-10 pull-right link text-master">
          <i class="pg-more"></i>
        </a>
        <!-- END Header Controler !-->
      </div>
    </div>
    <!-- END View Header !-->
    <div data-init-list-view="ioslist" class="list-view boreded no-top-border">
      <div class="list-view-group-container" v-for="group in groups">        
        <div class="list-view-group-header text-uppercase">{{ group.title }}</div>
        <ul>
          <!-- BEGIN Chat User List Item  !-->
          <li class="chat-user-list clearfix" v-for="item in group.items">
            <a data-view-animation="push-parrallax" data-view-port="#chat" data-navigate="view" class="" href="#">
              <span class="col-xs-height col-middle">
              <span class="thumbnail-wrapper d32 circular bg-success">
                  <img width="34" height="34" alt="" data-src-retina="../assets/img/profiles/1x.jpg" data-src="../assets/img/profiles/1.jpg" src="../assets/img/profiles/1x.jpg" class="col-top">
              </span>
              </span>
              <p class="p-l-10 col-xs-height col-middle col-xs-12">
                <span class="text-master">{{ item.name }}</span>
                <span class="block text-master hint-text fs-12">{{ item.message }}</span>
              </p>
            </a>
          </li>
          <!-- END Chat User List Item  !-->
        </ul>
      </div>    
    </div>
  </div>
  <!-- BEGIN Conversation View  !-->
  <Conversation />
</div>
</template>

<script>

  import Conversation from './conversation.vue';

  export default {
    name: 'Chat',
    components: {
      Conversation
    },
    data: () => ({
      groups: [
        {
          title: 'Today',
          items: [
            { id: '1', name: 'John Doe', message: "Hello There" }
          ]
        },
        {
          title: 'Older',
          items: [
            { id: '2', name: 'John Doe', message: "Hello There older" }
          ]
        }
      ]
    })
  }
</script>


// WEBPACK FOOTER //
// chat.vue?e6574e76